import { BalanceZoneStoreModel, CompanyStoreModel } from './store.model'
const SecureStorage = require('secure-web-storage')
var CryptoJS = require('crypto-js')

var SECRET_KEY = 'ASD7654fgjhdhas7'

var secureStorage = new SecureStorage(localStorage, {
  hash: function hash(key) {
    key = CryptoJS.SHA256(key, SECRET_KEY)

    return key.toString()
  },
  encrypt: function encrypt(data) {
    data = CryptoJS.AES.encrypt(data, SECRET_KEY)

    data = data.toString()

    return data
  },
  decrypt: function decrypt(data) {
    data = CryptoJS.AES.decrypt(data, SECRET_KEY)

    data = data.toString(CryptoJS.enc.Utf8)

    return data
  }
})

export interface localStorageModel {
  activeCompany: CompanyStoreModel
  activeBalanceZone: BalanceZoneStoreModel
  showCommunicationFile: boolean
  showCommunicationAdd: boolean
  showReleaseNotification: boolean
}

export const loadState = (): localStorageModel | undefined => {
  try {
    const serializedState = secureStorage.getItem('state')

    if (serializedState === null) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

export const saveState = (state): void => {
  try {
    const serializedState = JSON.stringify(state)
    secureStorage.setItem('state', serializedState)
  } catch {
    // ignore write errors
  }
}

export const removeState = () => {
  try {
    secureStorage.removeItem('state')
  } catch (err) {}
}
